import React from 'react';

const QuestionCard = ({ questionPair, questionIndex, selectedOption, onSelectOption }) => {
  return (
    <div 
      className="bg-white rounded-2xl p-6 lg:p-8 shadow-xl hover:shadow-2xl transition-all duration-500 border border-slate-100 group"
      style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.95) 100%)',
        backdropFilter: 'blur(10px)'
      }}
    >
      <div className="mb-6">
        <span className="inline-block px-3 py-1 rounded-full text-sm font-semibold bg-slate-100 text-slate-600 group-hover:bg-slate-200 transition-colors duration-300">
          Kérdés {questionIndex + 1}/30
        </span>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        {/* Option A */}
        <div 
          className={`relative p-6 rounded-xl cursor-pointer transition-all duration-500 transform hover:scale-105 border-2 ${
            selectedOption === 0 
              ? 'shadow-xl scale-105' 
              : 'hover:shadow-lg'
          }`}
          style={{
            background: selectedOption === 0 
              ? 'linear-gradient(135deg, #01918C 0%, #02c7c0 100%)'
              : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            borderColor: selectedOption === 0 ? '#01918C' : '#e2e8f0',
            color: selectedOption === 0 ? 'white' : '#334155',
            boxShadow: selectedOption === 0 
              ? '0 20px 40px rgba(1, 145, 140, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)' 
              : '0 4px 15px rgba(0, 0, 0, 0.08)'
          }}
          onClick={() => onSelectOption(questionIndex, 0)}
        >
          <div className="flex items-start gap-3">
            <div 
              className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                selectedOption === 0 ? 'bg-white/20' : 'bg-slate-200'
              }`}
              style={{ 
                color: selectedOption === 0 ? 'white' : '#64748b',
                backdropFilter: 'blur(10px)'
              }}
            >
              A
            </div>
            <div className="text-base leading-relaxed font-medium">
              {questionPair[0]}
            </div>
          </div>
        </div>

        {/* Option B */}
        <div 
          className={`relative p-6 rounded-xl cursor-pointer transition-all duration-500 transform hover:scale-105 border-2 ${
            selectedOption === 1 
              ? 'shadow-xl scale-105' 
              : 'hover:shadow-lg'
          }`}
          style={{
            background: selectedOption === 1 
              ? 'linear-gradient(135deg, #01918C 0%, #02c7c0 100%)'
              : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            borderColor: selectedOption === 1 ? '#01918C' : '#e2e8f0',
            color: selectedOption === 1 ? 'white' : '#334155',
            boxShadow: selectedOption === 1 
              ? '0 20px 40px rgba(1, 145, 140, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)' 
              : '0 4px 15px rgba(0, 0, 0, 0.08)'
          }}
          onClick={() => onSelectOption(questionIndex, 1)}
        >
          <div className="flex items-start gap-3">
            <div 
              className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                selectedOption === 1 ? 'bg-white/20' : 'bg-slate-200'
              }`}
              style={{ 
                color: selectedOption === 1 ? 'white' : '#64748b',
                backdropFilter: 'blur(10px)'
              }}
            >
              B
            </div>
            <div className="text-base leading-relaxed font-medium">
              {questionPair[1]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionCard;